const DAY_MS = 24 * 60 * 60 * 1000;

/**
 * Cycle numbers are the Linear cycle's title number ("Cycle 22"), not
 * Linear's internal number, which runs ahead of it.
 */
export const CYCLE_ANCHOR_NUMBER = 22;

/** Cycle 22 starts on Friday 2026-10-09 at 07:00 UTC. */
export const CYCLE_ANCHOR_START = new Date(Date.UTC(2026, 9, 9, 7));

export const CYCLE_LENGTH_DAYS = 14;

/** Work from before Cycle 1, which starts on 2025-12-19. */
export const BASELINE_CYCLE = 0;

/**
 * The Linear cycle a date falls in, by its title number. Dates before Cycle 1
 * return `BASELINE_CYCLE`. Linear starts winter cycles an hour later; that
 * hour is ignored.
 */
export const getCycle = (date: Date) => {
  const elapsed = date.getTime() - CYCLE_ANCHOR_START.getTime();
  const cycle =
    CYCLE_ANCHOR_NUMBER + Math.floor(elapsed / (CYCLE_LENGTH_DAYS * DAY_MS));

  return Math.max(cycle, BASELINE_CYCLE);
};
